import * as React from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  IconButton,
  CircularProgress,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { useEffect } from "react";
import {
  add_affiliate_transaction,
  team_list_selection_api,
  team_list_selection_api_new,
} from "src/DAL/salesTeam/SalesTeam";
// import {
//   add_affiliate_transaction,
//   affiliate_transaction_detail,
//   get_user_list_for_affiliate_transaction,
//   update_affiliate_transaction,
// } from "src/DAL/AffiliateTransactions/AffiliateTransactions";
// import ActiveLastBreadcrumb from "src/components/GeneralComponents/BreadCrums";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function AddOrUpdateAffiliateTransactions({ user_type }) {
  const navigate = useNavigate();
  const params = useParams();
  const { state, location } = useLocation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [formType, setFormType] = useState("ADD");
  const [serchText, setSerchText] = useState("");
  const [paidAmount, setPaidAmount] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userList, setUserList] = useState([]);
  const [inputs, setInputs] = useState({
    amount: 0,
    net_remaining: 166,
    transaction_for: "public",
    transaction_note: "",
    currency: "gbp",
    method: "cash",
  });
  console.log(state, "statestatestate");
  const getTransactionData = async () => {
    setIsLoading(true);
    let result = await affiliate_transaction_detail(params.transaction_id);
    if (result.code == 200) {
      setFormType("EDIT");
      setInputs(result.affiliatte_transaction);
      setPaidAmount(result.affiliatte_transaction.amount);
      setSelectedUser(result.user_info);
      setIsLoading(false);
    } else {
      navigate(`/affiliate-transactions`);
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = {
      user_id: selectedUser._id,
      amount: inputs.amount,
      transaction_note: inputs.transaction_note,
      currency: inputs.currency,
      transaction_for: "sub_delegates",
      method: inputs.method,
    };

    if (inputs.amount >= 1) {
      const result =
        formType === "ADD"
          ? await add_affiliate_transaction(formData)
          : await update_affiliate_transaction(formData, params.transaction_id);
      if (result.code === 200) {
        enqueueSnackbar(result.message, { variant: "success" });
        if (params.delegate_id) {
          navigate(-1);
        } else {
          navigate(-1);
        }
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    } else {
      enqueueSnackbar("payable amount must be greater 0", {
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    if (name === "transaction_for") {
      setSelectedUser(null);
      setSerchText("");
    }
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const getUserList = async () => {
    let id = serchText.length < 1 ? params?.delegate_id : "";
    const result = await team_list_selection_api_new(serchText);
    if (result.code === 200) {
      console.log(result, "resultresultresult");
      setUserList(result.sales_team);
      // if (serchText.length < 1) {
      //   if (params.delegate_id && inputs.transaction_for == "delegates") {
      //     let selected = result.users.find(
      //       (val) => val._id == params.delegate_id
      //     );
      //     setSelectedUser(selected);
      //     setIsLoading(false);
      //   }
      // }

      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const value = event.target.value;
    setSerchText(value);
  };

  let breadCrumbMenu = [
    {
      title: "Delegates",
      navigation: -1,
      active: false,
    },
    {
      title: state
        ? state?.first_name + " " + state?.last_name + " (" + state?.email + ")"
        : formType === "ADD"
        ? "Add Affiliate Transaction"
        : "Edit Affiliate Transaction",
      active: true,
    },
  ];

  useEffect(() => {
    if (params && params.transaction_id) {
      getTransactionData();
    }
  }, []);

  useEffect(() => {
    if (serchText.length % 3 === 0) {
      getUserList();
    }
  }, [serchText]);

  useEffect(() => {
    if (state) {
      setSelectedUser(state);
    }
  }, [state]);

  useEffect(() => {
    if (params.delegate_id) {
      setInputs((values) => ({
        ...values,
        ["transaction_for"]: "delegates",
      }));
    }
  }, [params]);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  console.log(userList, "userListuserList");
  return (
    <div className="container">
      <div className="row mobile-margin display-flex">
        <div className="col-12 d-flex">
          <span>
            <IconButton
              className="back-screen-button mb-4"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
          </span>
          {state ? (
            <h2 className="ms-2">Pay Commission</h2>
          ) : (
            <h2 className="ms-2">{`${
              formType === "ADD" ? "Add" : "Edit"
            } Commission Payouts`}</h2>
          )}
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Transaction For *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="transaction_for"
                required
                value={inputs.transaction_for}
                label="Transaction For *"
                onChange={handleChange}
              >
                <MenuItem value="public">Public User</MenuItem>
                <MenuItem value="delegates">Delegate User</MenuItem>
              </Select>
            </FormControl>
          </div>{" "} */}
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <Autocomplete
              loading
              id="tags-outlined"
              options={userList}
              getOptionLabel={(option) =>
                option.first_name +
                " " +
                option.last_name +
                " (" +
                option.email +
                ")"
              }
              filterSelectedOptions
              value={selectedUser}
              onChange={(event, newValue) => {
                setSelectedUser(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Select Sales Team"}
                  onChange={handleSearch}
                />
              )}
            />
          </div>
          {selectedUser && (
            <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
              <TextField
                id="outlined-basic"
                label="Net Remaining"
                variant="outlined"
                fullWidth
                disabled
                name="net_remaining"
                value={
                  selectedUser?.commission_due == undefined
                    ? 0
                    : selectedUser?.commission_due +
                      (formType === "EDIT" ? paidAmount : 0)
                }
                onChange={handleChange}
              />
            </div>
          )}
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <TextField
              id="outlined-basic"
              label="Payable Amount"
              variant="outlined"
              fullWidth
              required
              type="float"
              name="amount"
              value={inputs.amount}
              InputProps={{
                inputProps: {
                  min: 1,
                  max:
                    selectedUser?.commission_due +
                    (formType === "EDIT" ? paidAmount : 0),
                },
              }}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Plan Currency *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="currency"
                value={inputs.currency}
                label="Plan currency"
                onChange={handleChange}
              >
                <MenuItem value="usd">Dollar</MenuItem>
                <MenuItem value="gbp">UK Pounds</MenuItem>
                <MenuItem value="eur">Euro</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth disabled>
              <InputLabel id="demo-simple-select-label">
                Payment Method *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="method"
                required
                disabled
                value={inputs.method}
                label="Payment Method *"
                onChange={handleChange}
              >
                {/* <MenuItem value="stripe">Stripe</MenuItem> */}
                <MenuItem value="cash">Cash</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-12 mt-4">
            <FormControl fullWidth>
              <TextField
                id="outlined-multiline-flexible"
                label="Transaction Note"
                multiline
                rows={6}
                name="transaction_note"
                value={inputs.transaction_note}
                onChange={handleChange}
              />
            </FormControl>
          </div>
          <div className="text-end mt-4">
            {formType == "ADD" && selectedUser?.commission_due === 0 ? (
              <Tooltip title="You can't pay this user because this user has 0 remaining commission">
                <span
                  className="small-contained-button cursor-pointer"
                  disabled
                >
                  {formType == "ADD" ? "Submit" : "Update"}
                </span>
              </Tooltip>
            ) : (
              <button className="small-contained-button">
                {formType == "ADD" ? "Submit" : "Update"}
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}
